module.exports = __webpack_public_path__ + "img/selbalad_logo.113615d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/selbalad_logo.png
// module id = ./assets/img/media/arabic/selbalad_logo.png
// module chunks = 0 12